import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class CollapseIcon extends Component {
  render() {
    const { collapsed } = this.props;

    return (
      <i
        className={classnames('fas', 'mr-1', {
          'fa-arrow-down': collapsed,
          'fa-arrow-right': !collapsed,
        })}
        style={{ fontSize: 18 }}
        aria-hidden="true"
      />
    );
  }
}

CollapseIcon.propTypes = {
  collapsed: PropTypes.bool.isRequired,
};

export default CollapseIcon;
